import { useTranslation } from 'next-i18next';

import { Title } from '@components/molecules/cpdEnrollment/title';
import { getCpdBundleLicenseTitleKey, getCpdLicenseTitleKey } from 'src/helpers/utils';
import {
  ApplicantTypeEnum,
  CPDRegulatorTypeEnum,
  LicenseRenewalTypeEnum,
  CPDLicenseTypeEnum,
  ICPDCourse,
} from 'src/interfaces';

type Props = {
  regulator: CPDRegulatorTypeEnum;
  licenseRenewal: LicenseRenewalTypeEnum;
  applicantType: ApplicantTypeEnum;
  licenseType: CPDLicenseTypeEnum;
  cpdCourses: ICPDCourse[];
  isBundle?: boolean;
};

type FormLicense = {
  applicantType: ApplicantTypeEnum;
  licenseType: CPDLicenseTypeEnum;
};

const LicenseTitle = ({
  regulator,
  licenseRenewal,
  applicantType,
  licenseType,
  cpdCourses,
  isBundle = false,
}: Props) => {
  const { t } = useTranslation();

  if (!isBundle) {
    return (
      <Title
        title={t(getCpdLicenseTitleKey(regulator, licenseRenewal, applicantType, licenseType).toLowerCase())}
        subtitle={t('cpd_enrollment.please_verify_detail')}
      />
    );
  }

  const data: FormLicense[] = [];

  for (const course of cpdCourses) {
    for (const licenseType of course.licenseTypes) {
      const courseLicense = {
        applicantType: course.applicantType,
        licenseType,
      };

      const isAlreadyInArray = data.some(
        (item) => item.applicantType === courseLicense.applicantType && item.licenseType === courseLicense.licenseType,
      );

      if (!isAlreadyInArray) data.push(courseLicense);
    }
  }

  const sortByLicenseTypeName = (a: FormLicense, b: FormLicense) => (a.licenseType >= b.licenseType ? -1 : 1);
  const sortByApplicantTypeName = (a: FormLicense, b: FormLicense) => (a.applicantType >= b.applicantType ? -1 : 1);

  const sortedData = data.sort(sortByLicenseTypeName).sort(sortByApplicantTypeName);

  return (
    <Title
      title={t(
        getCpdBundleLicenseTitleKey(
          regulator,
          sortedData.map((item) => `${item.applicantType}_${item.licenseType}`).join('_'),
        ).toLowerCase(),
      )}
      subtitle={t('cpd_enrollment.please_verify_detail')}
    />
  );
};

export default LicenseTitle;
